import { useMemo } from "react";
import { Constantes } from "@/ts/constantes";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures, } from "@tanstack/react-table";
import { ModalIniciarFase } from "./components/IniciarFase";
import { ModalVerImputacionesFase } from "./components/VerImputacionesFase";
import { ModalCerrarFase } from "./components/CerrarFase";
import { useDisclosureData } from "@/hooks/useModal";
import { ModalImputarFase } from "./components/ImputarFase";
import type { InfoFase, InfoOF } from "@/hooks/Api/OrdenesFabricacion";
import { CommonFeatures } from "@/hooks/useTanstackTable";


interface TablaFasesOFProps { readonly of: InfoOF; }
export function TablaFasesOF(props: TablaFasesOFProps) {
	const discloseIniciar = useDisclosureData<number | null>(null);
	const discloseImputar = useDisclosureData<number | null>(null);
	const discloseCerrar = useDisclosureData<number | null>(null);
	const discloseImputaciones = useDisclosureData<number | null>(null);


	const { columns, features } = useMemo(() => Columns({
		openCerrar: discloseCerrar.open,
		openImputaciones: discloseImputaciones.open,
		openImputar: discloseImputar.open,
		openIniciar: discloseIniciar.open
	}), [discloseCerrar.open, discloseImputaciones.open, discloseImputar.open, discloseIniciar.open]);



	return (
		<>
			<TypedTable
				className="dataTable display"
				data={props.of.fases}
				features={features}
				columns={columns}

				noResultsMessage="No se encontraron fases"
				errorMessage="Error al cargar las fases"
				isLoading={false}
				isError={false}
			/>

			<ModalIniciarFase
				idOF={props.of.idOF}
				idFase={discloseIniciar.data}
				show={discloseIniciar.isOpen}
				close={discloseIniciar.close}
			/>
			<ModalImputarFase
				idOF={props.of.idOF}
				idFase={discloseImputar.data}
				show={discloseImputar.isOpen}
				close={discloseImputar.close}
			/>
			<ModalCerrarFase
				idOF={props.of.idOF}
				idFase={discloseCerrar.data}
				show={discloseCerrar.isOpen}
				close={discloseCerrar.close}
			/>
			<ModalVerImputacionesFase
				idOF={props.of.idOF}
				descConjunto={props.of.descripcion}
				idFase={discloseImputaciones.data}
				show={discloseImputaciones.isOpen}
				close={discloseImputaciones.close}
			/>
		</>
	);
}

interface ColumnProps {
	openCerrar: (idFase: number) => void,
	openImputaciones: (idFase: number) => void,
	openImputar: (idFase: number) => void,
	openIniciar: (idFase: number) => void;
}
function Columns({ openCerrar, openImputaciones, openImputar, openIniciar }: ColumnProps) {
	const columnHelper = createColumnHelper<typeof features, InfoFase>();
	const features = tableFeatures(CommonFeatures);

	const displayDate = (dateTs: number | null) => {
		if (dateTs == null) return "-";
		const date = new Date(dateTs * 1000);
		const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };

		return date.toLocaleString("es-ES", options);
	};
	const getAccionesFase = (row: InfoFase) => {
		const onIniciarFase = () => { openIniciar(row.idFase); };
		const onImputarFase = () => { openImputar(row.idFase); };
		const onCerrarFase = () => { openCerrar(row.idFase); };
		const onVerImputaciones = () => { openImputaciones(row.idFase); };


		if (row.idPuesto == Constantes.PUESTO_OPE) {
			if (row.timestampIni == null)
				return (
					<div className="btnsFase">
						<button className="btnPrimary" onClick={onIniciarFase} type="button">Iniciar</button>
					</div>
				);

			if (row.cantLanzada > row.cantAcabada && row.timestampFin == null)
				return (
					<div className="btnsFase">
						<button disabled type="button">Entrega de la OPE sin completar</button>
					</div>
				);

			if (row.timestampFin == null)
				return (
					<div className="btnsFase">
						<button className="btnSecondary" onClick={onCerrarFase} type="button"> Cerrar </button>
					</div>
				);

			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Stilliscic
			if (row.timestampFin != null)
				return (
					<div className="btnsFase">
						{/* <button className="btnCerrarOF"> Archivar OF</button> */}
					</div>
				);
		} else {
			if (row.timestampIni == null)
				return (
					<div className="btnsFase">
						<button className="btnPrimary" onClick={onIniciarFase} type="button">Iniciar</button>
						<button className="btnPrimary" onClick={onImputarFase} type="button"> Imputar </button>
					</div>
				);

			if (row.cantLanzada > row.cantAcabada && row.timestampFin == null)
				return (
					<div className="btnsFase">
						<button className="btnPrimary" onClick={onImputarFase} type="button"> Imputar </button>
						<button className="btnSecondary" onClick={onVerImputaciones} type="button"> Ver Imputaciones </button>
						<button className="btnSecondary" onClick={onCerrarFase} type="button"> Cerrar </button>
					</div>
				);

			if (row.timestampFin == null)
				return (
					<div className="btnsFase">
						<button className="btnPrimary" onClick={onImputarFase} type="button"> Imputar </button>
						<button className="btnSecondary" onClick={onVerImputaciones} type="button"> Ver Imputaciones </button>
						<button className="btnSecondary" onClick={onCerrarFase} type="button"> Cerrar </button>
					</div>
				);

			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Stilliscic
			if (row.timestampFin != null)
				return (
					<div className="btnsFase">
						<button className="btnSecondary" onClick={onVerImputaciones} type="button"> Ver Imputaciones </button>
						{/* <button className="btnCerrarOF"> Archivar OF</button> */}
					</div>
				);
		}
	};
	const renderDesc = (original: InfoFase, desc: string) => {
		if (original.idPuesto == Constantes.PUESTO_OPE) {
			return <span style={{ color: "red", fontWeight: "bold" }}>OPE - {desc}</span>;
		} else {
			return desc;
		}
	};

	const columns = columnHelper.columns([
		columnHelper.accessor("idFase", { header: "Fase", meta: { className: "dt-center", hidden: !Constantes.existenFases } }),
		columnHelper.accessor("descripcion", { header: "Descripción", meta: { className: "dt-left" }, cell: ({ row, getValue }) => renderDesc(row.original, getValue()) }),

		columnHelper.accessor("cantLanzada", { header: "Cant. Lanzada", meta: { className: "dt-center" } }),
		columnHelper.accessor("cantAcabada", { header: "Cant. Acabada", meta: { className: "dt-center" } }),

		columnHelper.accessor("timestampIni", { header: "Fecha inicio", meta: { className: "dt-center" }, cell: info => displayDate(info.getValue()) }),
		columnHelper.accessor("timestampFin", { header: "Fecha fin", meta: { className: "dt-center" }, cell: info => displayDate(info.getValue()) }),

		columnHelper.display({ id: "Acciones", header: "Acciones", meta: { className: "dt-center" }, cell: info => getAccionesFase(info.row.original) }),
	]);
	return { columns, features };
}